// Reglas de mayúsculas para nombres que terminan impresos en documentos (PIPC, RIC, Carta,
// cotización). Única fuente: empresas, sucursales y perfil del invitado importan de aquí.

const NAME_PARTICLES = new Set(['de', 'del', 'la', 'las', 'los', 'y']);

// Error de dedo típico: 2+ mayúsculas seguidas de minúsculas en la misma palabra
// ("TIenda", "UNo"). No marca siglas completas (OXXO, CONEM, SA), palabras normales
// (Tienda) ni nombres con mayúscula interna legítima (McDonald's, iShop).
const CASE_TYPO = /^(\P{L}*)(\p{Lu}{2,}\p{Ll}[\p{L}]*)(\P{L}*)$/u;

const fixWord = (word) => {
  const m = word.match(CASE_TYPO);
  if (!m) return word;
  const [, prefix, core, suffix] = m;
  return prefix + core.charAt(0) + core.slice(1).toLocaleLowerCase('es-MX') + suffix;
};

/** Sugerencia corregida si el texto tiene errores de mayúsculas; null si está bien. */
export const suggestCaseFix = (value) => {
  if (!value) return null;
  const fixed = value.split(/(\s+)/).map((part) => (/\s/.test(part) ? part : fixWord(part))).join('');
  return fixed !== value ? fixed : null;
};

/** "jUAN DE la PEÑA" -> "Juan de la Peña" (mismo criterio que UserService.capitalizeName). */
export const capitalizePersonName = (value) => value.trim().replace(/\s+/g, ' ').toLocaleLowerCase('es-MX').split(' ')
  .map((word, i) => (i > 0 && NAME_PARTICLES.has(word))
    ? word
    : word.replace(/(^|[-'])(\p{L})/gu, (m, sep, letter) => sep + letter.toLocaleUpperCase('es-MX')))
  .join(' ');
